import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestTogglePackActive } from "./togglePackActive.request";

const useTogglePackActive = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestTogglePackActive,
    ...options
  });
};

export default useTogglePackActive;
